export default "__VITE_ASSET__gHapzGkJ__"